import { render, staticRenderFns } from "./NotificationNavItem.vue?vue&type=template&id=397ab8e6&scoped=true"
import script from "./NotificationNavItem.vue?vue&type=script&lang=js"
export * from "./NotificationNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ab8e6",
  null
  
)

export default component.exports